export default {
  methods: {
    getSortableClass (sorted, direction) {
      const classList = []
      if (sorted) {
        classList.push('sorted')
        if (direction === 'DESC') {
          classList.push('reverse')
        }
      }
      return classList.join(' ')
    }
  }
}
